import { Text } from '@belong/ui';
import { PaymentMethodIcon } from 'components/PaymentMethodIcon/payment-method-icon';
import PaymentMethodModel from 'models/common/PaymentMethod';
import { PaymentMethod } from 'models/enums';
import { getFeeFromPaymentMethod } from 'models/utilities/paymentMethods';
import { PAY_AS_YOU_GO_STRINGS } from '../strings';
import { PaygPaymentMethodMenu } from './payg-payment-method-menu';

const STRINGS = PAY_AS_YOU_GO_STRINGS.confirmStep;

type Props = {
  onChangingMethod?: (isChanging: boolean) => void;
  paymentMethod: PaymentMethodModel;
};

export function PaygPaymentMethodRow({
  onChangingMethod,
  paymentMethod,
}: Props) {
  const isAch = paymentMethod.paymentMethod === PaymentMethod.Ach;
  const bankName = paymentMethod.achDetails?.bankName;
  const cardType = paymentMethod.creditCardDetails?.cardType;
  const accountLabel = isAch ? paymentMethod.achDetails?.accountType : 'Card';

  return (
    <div className="flex w-full items-center justify-between gap-sm">
      <div className="flex items-center gap-2sm">
        <PaymentMethodIcon
          bankName={bankName}
          cardType={cardType}
          paymentMethod={paymentMethod.paymentMethod}
        />
        <div className="flex flex-col gap-2xs">
          <Text className="text-navy" fontWeight="semibold">
            {isAch ? bankName : cardType}
          </Text>
          <Text className="text-navy" variant="p1">
            {`${accountLabel} ending in ${paymentMethod.lastDigits} · `}
            <span className="uppercase text-green">
              {getFeeFromPaymentMethod(paymentMethod.paymentMethod, true)}
            </span>
          </Text>
        </div>
      </div>
      <PaygPaymentMethodMenu
        menuButtonLabel={
          <span className="body font-semibold uppercase text-navy transition-colors duration-hover hover:text-dark-navy">
            {STRINGS.change}
          </span>
        }
        onChangingMethod={onChangingMethod}
        selectedPaymentMethodId={paymentMethod.accountId}
      />
    </div>
  );
}
